<template>
  <div>
    <svg
      v-if="trx.finance_approve_status == 1"
      xmlns="http://www.w3.org/2000/svg"
      class="w-4 h-4"
      viewBox="0 0 48 48"
    >
      <path
        fill="none"
        stroke="currentColor"
        stroke-linejoin="round"
        stroke-width="4"
        d="M27.6 18.6v-7.2A5.4 5.4 0 0 0 22.2 6L15 22.2V42h20.916a3.6 3.6 0 0 0 3.6-3.06L42 22.74a3.6 3.6 0 0 0-3.6-4.14zM15 22h-4.806C8.085 21.963 6.283 23.71 6 25.8v12.6a4.158 4.158 0 0 0 4.194 3.6H15z"
      />
    </svg>
    <svg
      v-if="trx.finance_approve_status >= 2"
      xmlns="http://www.w3.org/2000/svg"
      class="w-4 h-4"
      viewBox="0 0 20 20"
    >
      <path
        fill="currentColor"
        fill-opacity=".89"
        fill-rule="evenodd"
        d="M15.807.939c.396.367.655 1.133.706 1.595c.59.366 1.288 1.104 1.349 2.494c1.053.731 1.853 2.083.854 4.06c.58.54 1.227 2.188.395 3.516c-.969 1.552-3.075 1.66-5.174 1.383c.56 1.565.77 3.009-.116 4.488C12.94 19.787 11.724 20 11.308 20c-1.138 0-1.918-.979-2.234-2.283c-.115-.364-.246-1.224-.297-1.45c-.265-1.44-1.156-2.592-2.67-3.453a11.392 11.392 0 0 0-2.123-.946h-2.34c-.521 0-1.144-.527-1.144-1.165V3.067c.074-.722.475-1.082 1.202-1.082h3.11c1.364-.31 2.724-.642 4.079-.995C10.2.637 10.487.52 11.403.268c2.053-.532 3.478-.24 4.404.67m-2.382.424c-.819 0-1.856.252-2.316.399c-.162.051-.446.135-.745.221l-.3.087l-.288.082l-.56.158s-1.41.378-4.173 1.02c-.103.012-.158.02-.166.022v7.38c1.511.582 2.688 1.288 3.53 2.118c1.264 1.244 1.615 2.368 1.822 3.807c.118.723.309 1.306.597 1.705a.65.65 0 0 0 .342.251c.147.047.35.05.783-.184c.433-.236.99-.853 1.095-1.772c.07-.893-.17-1.667-.492-2.481a15.705 15.705 0 0 0-.357-.822c-.218-.413.11-1.099.786-.95c.906.255 3.154.6 4.422 0c.737-.427.92-1.116.547-2.066a1.74 1.74 0 0 0-.495-.553c-.17-.102-.502-.544-.103-1.045c.396-.635.975-1.928-.49-2.734a.656.656 0 0 1-.34-.57c-.02-.274.024-1.29-.73-1.744c-.18-.097-.397-.177-.52-.41c-.078-.154-.103-.528-.103-.528c-.103-.632-.245-1.222-1.746-1.391M3.519 3.348H1.861v7.157h1.658z"
      />
    </svg>
    <template v-if="trx.type == 'YATIRIM'">
      <template v-if="trx.delivery_iban == null">
        <DeliveryIban :trx="trx"></DeliveryIban
      ></template>
      <template v-if="trx.comment"> - {{ trx.comment }}</template>

      <template v-if="trx.status_id == 2">
        <Deposit :id="trx.id"></Deposit
      ></template>
    </template>
    <template v-else> 

      <form
        class="text-xs mt-2 flex space-x-2 items-center"
        @submit.prevent="commentChange(trx.id)"
      >
        <div>
          <div>
            <label>Açıklama</label>
            <textarea
            required
              v-model="comment"
              class="uk-textarea border rounded-lg"
            ></textarea>
          </div>
          <button class="global-button-xs mt-2" type="submit">
            Açıklamayı kaydet
          </button>
        </div>
      </form>
    </template>

    <template v-if="trx.gateway_id == 1">
      <div class="text-xs my-2 bg-white flex flex-col border rounded-lg">
        <div class="p-1 flex flex-col justify-between items-start">
          <label class="font-semibold">MÜŞTERİ HESAP BİLGİSİ</label>
          <span style="white-space: pre-wrap; "
            >{{ trx.iban_name }} {{ trx.iban }}
          </span>
        </div>
      </div>
    </template>
    <template v-if="trx.gateway_id == 5">
      <div class="text-xs my-2 bg-white flex flex-col border rounded-lg">
        <div class="p-1 flex flex-col justify-between items-start">
          <label class="font-semibold">MÜŞTERİ CÜZDAN BİLGİSİ</label>
          <span style="white-space: pre-wrap; ">
            {{ trx.iban_name }} {{ trx.iban }}</span
          >
        </div>
      </div>
    </template>
    <template v-if="trx.comment"> - {{ trx.comment }}</template>
  </div>
</template>
<script>
import http from "../../services/http"; 
import DeliveryIban from "./Forms/DeliveryIban";
import Deposit from "./Forms/Deposit";

export default {
  data() {
    return { comment: "" };
  },
  props: ["trx"],
  mounted() {
    this.comment = this.trx.comment;
  },
  methods: {
    commentChange(trxId) {
      http.transaction
        .changeComment(trxId, { comment: this.comment })
        .then((resp) => {
          if (resp.data.success) {
            this.$root.successMessage("Açıklama kaydedildi");

            // EventBus.$emit("transactionReload", true);
          }
        })
        .catch((msg) => {
          this.$root.errorMessage(msg.response.data);
        });
    },
  },
  components: { DeliveryIban, Deposit },
};
</script>
